module.exports = __webpack_public_path__ + "img/photo_2024-03-21_18-07-43.5c373445.jpg";